import React from "react";

import Header$ from "@deosite/sections/Header";
import ButtonMinimalIcon from "@deosite/components-new/buttons/ButtonMinimalIcon";

import { useMinicart } from "@deosite/api/hooks/common/useMinicart";
import { useCart } from "@deosite/api/hooks/REST/CartProvider";

import icons from "@deosite/mock-data/icons";

const Header = props => {
  const { toggleMinicartVisibility } = useMinicart();
  const { cart } = useCart();
  const itemsAmountInCart =
    cart && cart.items
      ? cart.items.reduce(
          (prev, next) => parseInt(prev) + parseInt(next.quantity),
          0
        )
      : 0;

  const propsExt = {
    ...props,
    itemsAmountInCart,
    onCartClick: toggleMinicartVisibility,
    button: (
      <ButtonMinimalIcon
        sx={{
          width: "auto",
          height: "auto"
        }}
      />
    ),
    logo: icons.logoIcon
  };
  return <Header$ {...propsExt} />;
};

export default Header;
